import { RegistrationResponse } from '../../models/registration/registration-response.interface';
import { mockRegisteredItem } from '../registered-item/registered-item.mock';

export const mockRegistrationResponse: RegistrationResponse = [
  mockRegisteredItem,
];
